<template>
  <div class="us">
    <!-- <img src="../../assets/logo.png" alt />
    <p>湖北汇林建材有限公司旗下所属湖北嘉贝乐建材有限公司是专业研发、生产和销售水性NEH地坪涂料、内外墙涂料、K11、JS、丙烯酸、有机硅等防水、瓷砖胶粘剂、彩色瓷砖填缝剂、内外墙专业腻子、界面剂、地面固化砂浆、外墙外保温砂浆、装饰砂浆、自流平砂浆等系列产品的综合服务型企业.</p>
    <p>嘉贝乐与美国陶氏化学公司建立有长期的战略伙伴关系,在建筑用化学品领域为陶氏授权合作商.依托美国陶氏化学公司强大的研发平台,专注于绿色环保系列水性无毒产品的研发和生产,应用业内最新一代的聚合物技术体系,采用知名品牌原材料,有效的保证产品的优良品质.致力于向全社会提供绿色环保、高性能的系统性产品服务.同时为《单层防水装饰砂浆标准》行业标准参编单位.力求推动建材行业环保创新,打造一条绿色地平线,营造健康生活新环境.</p>-->
    <div v-html="inner"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inner: ""
    };
  },
  created() {
    console.log(this.$route.query);
    let { id } = this.$route.query;
    this.$http({
      url: "helpDetail",
      data: {
        id
      }
    }).then(res => {
      this.inner = this.escape2Html(res.content);
    });
  },
  methods: {
    escape2Html(str) {
      let arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
        return arrEntities[t];
      });
    }
  }
};
</script>





<style lang="less" scoped>
.us {
  width: 100%;
  box-sizing: border-box;
  padding: 0 24px;
  img {
    display: block;
    width: 300px;
    margin: 55px auto;
  }
  p {
    font-size: 24px;
    color: #333;
    margin: 30px 0;
  }
}
</style>
